import React, { useEffect, useState } from 'react';
import { BundleProps } from 'utils/types';
import {
  StyledBingoPop,
  StyledBingoPopEmblem,
  StyledBingoPopPriceContainer,
} from './style';
import { BingoPopProducts } from './Products';
import { BundlePrice } from 'components/BundlePrice';
import { useGetBadge } from 'utils/useGetBadge';
import { IEmblemBadge } from 'components/Badge/types';
import { SpecialOfferProps } from 'templates/SpecialOffer/types';
import { EBundlesInternalViewModel } from 'utils/enums';

interface IBingoPopGeneralProps {
  prices: BundleProps['prices'];
  productList: BundleProps['productList'];
  backgroundSrc: BundleProps['backgroundSrc'];
  backgroundColor: BundleProps['backgroundColor'];
  emblemBadges: BundleProps['emblemBadges'];
  bundleButtonColor: BundleProps['bundleButtonColor'];
  bundleButtonTextColor: BundleProps['bundleButtonTextColor'];
  selectOffer?: SpecialOfferProps['selectOffer'];
}

export const BingoPopGeneral: React.FC<IBingoPopGeneralProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#E2AE54',
  },
  emblemBadges = [],
  bundleButtonColor = {
    colorOne: '#85e415',
    colorTwo: '#70ca0d',
  },
  bundleButtonTextColor = 'white',
  selectOffer,
}) => {
  const emblem = useGetBadge<IEmblemBadge>(emblemBadges);

  return (
    <StyledBingoPop
      className={'bingo-pop-wrapper'}
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      onClick={selectOffer}
    >
      {emblem?.imageUrl && (
        <StyledBingoPopEmblem>
          <img alt={'emblem-badge'} src={emblem.imageUrl} />
        </StyledBingoPopEmblem>
      )}
      <BingoPopProducts productList={productList} />
      <StyledBingoPopPriceContainer
        className={'price-container'}
        bundleButtonColor={bundleButtonColor}
      >
        <BundlePrice
          prices={prices}
          type={EBundlesInternalViewModel.BINGO_POP}
          buttonTextColor={bundleButtonTextColor}
          textShadow={
            '0px 1px 1px rgba(0, 0, 0, 0.3), -1px 1px 0 #326A00, 1px -1px 0 #326A00,-1px -1px 0 #326A00, 1px 1px 0 #326A00'
          }
          isTextAutoResized={true}
        />
      </StyledBingoPopPriceContainer>
    </StyledBingoPop>
  );
};
